import api from "src/apis/api"

export async function fetchAuditLogs({ page = 1, per_page = 25, q = "" } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (q) params.set("q", q)

  const { data } = await api.get(`/api/v1/audit_logs?${params}`)
  return data
}
